import React, { useEffect, useState } from 'react'
import { CButton, CCallout, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CFormLabel } from '@coreui/react'
import Select from 'react-select'
import { Filter } from 'lucide-react'

const AutoScheduling = ({ notSchedule, setCheckedPatients, setVisible, setPatientDate, setActiveTab, setManual, setLoader, handleAutoSchedule, checkedPatients, providers, facilities }) => {
  const [checked, setChecked] = useState([])
  const [filterData, setFilterData] = useState(notSchedule || [])
  const [selectedFilters, setSelectedFilters] = useState({
    status: null,
    provider: null,
    facility: null,
    date: null,
  })
  const handleCheckboxChange = (patientID) => {
    setChecked((prevChecked) => (prevChecked.includes(patientID) ? prevChecked.filter((id) => id !== patientID) : [...prevChecked, patientID]))
  }
  // const handleSubmit = () => {

  //     setCheckedPatients(checked);

  //     if (checked.length > 0) {
  //             handleAutoSchedule()
  //     } else if (checked.length == 0) {
  //         handleAutoSchedule()
  //     }

  // }
  const handleSubmit = () => {
    setCheckedPatients(checked)
    if (checked.length > 0 || checked.length === 0) {
      handleAutoSchedule(checked)
    }
  }

  const handleCheckedData = () => {
    setCheckedPatients(checked)
  }

  const handleSelectAll = () => {
    if (checked.length === notSchedule.length) {
      setChecked([])
    } else {
      setChecked(notSchedule.map((patient) => patient.PatientID))
    }
  }

  const handleTypeFilter = (e, type) => {
    setSelectedFilters((prev) => ({ ...prev, [type]: e }))
    let filter
    if (type === 'status') {
      filter = filterData.filter((item) => item?.Status === e?.value)
    } else if (type === 'provider') {
      filter = filterData.filter((item) => item?.Provider === e?.value)
    } else if (type === 'facility') {
      filter = filterData.filter((item) => item?.FacilityName === e?.label)
    } else if (type === 'date') {
      filter = filterData.filter((item) => item?.Date === e?.value)
    }
    setFilterData(filter)
  }

  // useEffect(() => {
  //     if (checkedPatients.length > 0) {
  //         handleAutoSchedule()
  //     }
  // }, [checkedPatients])
  return (
    <div>
      <div className="d-flex justify-content-end gap-1">
        <CDropdown>
          <CDropdownToggle variant="ghost" className="p-0 border-0">
            <CButton variant="outline" color="info">
              Filter{' '}
              <span>
                <Filter size={16} />
              </span>
            </CButton>
          </CDropdownToggle>
          <CDropdownMenu className="" style={{ width: '300px', top: '45px', right: '0' }}>
            <CDropdownItem className="no-hover bg-secondary">
              {' '}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <CFormLabel style={{ flex: 1, marginRight: '8px' }}>Type</CFormLabel>
                <Select
                  options={[
                    { value: 'NewPatient', label: 'New Note' },
                    { value: 'Follow Up', label: 'Follow Up' },
                  ]}
                  onChange={(e) => handleTypeFilter(e, 'status')}
                  value={selectedFilters.status}
                  closeMenuOnSelect={false}
                  className="w-100"
                />
              </div>
            </CDropdownItem>
            {/* <CDropdownItem className=" no-hover bg-secondary" >
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                                <CFormLabel style={{ flex: 1, marginRight: '8px' }}>Provider</CFormLabel>
                                <Select
                                    options={providers.map((item) => ({ value: item.ID, label: item.Name })) || []}
                                    value={selectedFilters.provider}
                                    onChange={(e) => handleTypeFilter(e, 'provider')}
                                    closeMenuOnSelect={false}
                                    className="w-100"
                                />
                            </div>

                        </CDropdownItem  > */}

            <CDropdownItem className="no-hover bg-secondary">
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <CFormLabel style={{ flex: 1, marginRight: '8px' }}>Facility</CFormLabel>
                <Select options={facilities || []} value={selectedFilters.facility} onChange={(e) => handleTypeFilter(e, 'facility')} closeMenuOnSelect={false} className="w-100" />
              </div>
            </CDropdownItem>

            {/* <CDropdownItem className="no-hover bg-secondary">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                                <CFormLabel style={{ flex: 1, marginRight: '8px' }}>Schedule Date</CFormLabel>
                                <Select
                                    options={[]}
                                    value={selectedFilters.date}
                                    onChange={(e) => handleTypeFilter(e, 'date')}
                                    closeMenuOnSelect={false}
                                    className="w-100"
                                />
                            </div>
                        </CDropdownItem> */}
          </CDropdownMenu>
        </CDropdown>
        <CButton variant="outline" color="info" onClick={handleSelectAll}>
          {' '}
          {checked.length === notSchedule.length ? 'Deselect All' : 'Select All'}
        </CButton>
      </div>
      <div className="" style={{ maxHeight: '400px', overflow: 'auto' }}>
        {filterData && filterData.length > 0 ? (
          filterData.map((patient) => (
            <CCallout key={patient.PatientID} color={patient.Status === 'Follow Up' ? 'warning' : 'success'} style={{ padding: '10px' }}>
              <input type="checkbox" className="form-check-input me-2" checked={checked.includes(patient.PatientID)} onChange={() => handleCheckboxChange(patient.PatientID)} />
              {`${patient.FirstName} ${patient.LastName}`}
            </CCallout>
          ))
        ) : (
          <div className="text-center text-muted py-3">No patient available</div>
        )}
      </div>

      <div className="d-flex justify-content-end gap-2 mt-3">
        <CButton
          color="secondary"
          variant="outline"
          style={{ fontSize: '0.9rem' }}
          onClick={() => {
            ;(setVisible(false),
              setPatientDate([]),
              setActiveTab(0),
              setManual([]),
              setSelectedFilters({
                status: null,
                provider: null,
                facility: null,
                date: null,
              }))
          }}
        >
          Close
        </CButton>
        <CButton
          color="primary "
          variant="outline"
          className={` ${filterData && filterData.length > 0 ? '' : 'disabled border-primary'}`}
          style={{ fontSize: '0.9rem' }}
          onClick={() => {
            handleSubmit()
          }}
        >
          Auto Schedule
        </CButton>
        <CButton
          color="primary "
          variant="outline"
          className={` ${checked.length == 0 ? 'disabled border-primary' : ''}`}
          style={{ fontSize: '0.9rem' }}
          onClick={() => {
            ;(setActiveTab(1), handleCheckedData())
          }}
        >
          {' '}
          Next{' '}
        </CButton>
      </div>
    </div>
  )
}

export default AutoScheduling
